import React, { useEffect, useRef, useState } from "react";
import { initiateKyc } from '../../actions/auth';

import actionIcon from "../../assets/img/icon/kyc-icon.png";

import './toDo.css';
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Vove, { VoveEnvironment } from "@vove-id/web-sdk";
import FormModal from "../FormModal";
import { initiateKycFlow, initiateVirtualAccountSetup } from "../../actions/user";
import { setUser } from "../../redux/slices/userSlice";
import { Modal } from "bootstrap";
import { formatLabel } from "../../actions/payments";

const AccountSetup = ({ userDetails }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [virtualAccountHolderStatus, setVirtualAccountHolderStatus] = useState(userDetails?.virtual_account_holder?.kyc_status);
  const [virtualAcctActive, setVirtualAcctActive] = useState(false);
  const handleAccountSetup = async () => {
    setLoading(true);
    try {
      const credentials = {};
      const responseData = await initiateVirtualAccountSetup(credentials, toast);
      if(responseData.status == 'success' || responseData.status == 'pending'){
        toast.success("Virtual account creation processing. You will be notified once completed.");
        setVirtualAccountHolderStatus(responseData.user.virtual_account_holder?.kyc_status);
        setLoading(false);
      }else{
        toast.error(responseData.message);
      }
    } 
    catch (err) {
      // toast.error("An error occurred while creating your virtual account details. Please try again.");
      // console.error(err);
    } 
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setVirtualAcctActive(['processing', 'approved', 'pending'].includes(virtualAccountHolderStatus));
  }, [virtualAccountHolderStatus])

  return (
    <>
      <section className="toDoList-card rounded-2 ">
        <div className="toDo-container">
          <div className="toDo-icon">
            <img src={actionIcon} alt="KYC Verification" className="img-fluid" />
          </div>
          <div className="toDo-text">
            <h4>Virtual Account Setup</h4>
            <p>
              {virtualAcctActive ? <>
                {virtualAccountHolderStatus?.toLowerCase() === 'pending' ? (
                  <>Virtual account creation currently processing</>
                ) : (
                  <>Your virtual account creation is currently being processed. You'll be notified once successfully created.</>
                )}
              </> : <>
                Set up your virtual account to start depositing NGN 
              </>}
            </p>
          </div>
          {!virtualAcctActive && 
          <button className="toDo-button" disabled={loading || virtualAcctActive} onClick={handleAccountSetup}>
            {loading ? (
              <div className="spinner-border spinner-border-sm text-light" role="status">
                <span className="visually-hidden">
                  Creating virtual account...
                </span>
              </div>
            ) : <div> 
              {virtualAcctActive ? formatLabel(virtualAccountHolderStatus) : 'Set-up Account'}
            </div>}
          </button>}
        </div>
      </section>
    </>
  );
};

export default AccountSetup;